import { IRevenueAgencyListTableLang } from '../../../types/lang'

export const revenueAgencyListTableLang: IRevenueAgencyListTableLang = {
	revenue_agency_list_table: {
		column_id: 'ID_ua',
		column_name: 'Name_ua',
		column_date_updated: 'Date Updated_ua',
		column_group: 'Group_ua',
		column_percent: 'Percent, %_ua',
		column_is_system: 'System_ua',
		column_is_active: 'Active_ua',
		column_is_hold: 'Hold_ua',
		column_fake_type: 'Fake Type_ua',
		column_history: 'History_ua',
		column_notes: 'Notes_ua'
	}
}